import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import HttpApi from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

// not like to use this?
// have a look at the Quick start guide
// for passing in lng and translations on init

i18n
// load translation using xhr -> see /public/locales
// learn more: https://github.com/i18next/i18next-xhr-backend
    .use(HttpApi)
    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    .use(LanguageDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        detection: {
            // `lng` below is what actually decides the initial language --
            // passing it overrides detection -- so this block only governs
            // where the choice is cached afterwards. 'path' used to be in the
            // order: it can never fire behind a HashRouter (the path is always
            // '/'), and if the router ever changed it would read '/register'
            // as a language, so it is gone rather than dormant.
            order: ['localStorage', 'navigator'],

            lookupQuerystring: 'lng',
            lookupLocalStorage: 'i18nextLng',

            // Cookie caching was configured but never worked: cookieDomain was
            // left at the placeholder 'myDomain', so the browser rejected every
            // write (verified in production -- no i18next cookie exists).
            // localStorage is what has always carried this.
            caches: ['localStorage'],
            excludeCacheFor: ['cimode']
        },
        // The only two bundles that exist under /public/locales. Without this,
        // a browser reporting anything else (de-DE, fr-FR, ...) makes i18next
        // request /locales/de/translation.json, which the SPA host answers with
        // a 200 carrying index.html -- i18next then fails to parse it as JSON
        // and falls back anyway. Declaring the supported set skips the request.
        supportedLngs: ['en', 'tr'],
        fallbackLng: 'en',
        // i18next's debug log is for development; in production it wrote its
        // internals to every visitor's console.
        debug: process.env.NODE_ENV === 'development',
        load: 'languageOnly',
        lng: localStorage.getItem("i18nextLng") || navigator.language,
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        }
    });

// index.html ships lang="en" and nothing was updating it, so a Turkish page
// still declared itself English and a screen reader read Turkish copy with
// English phonetics. The detection block used to carry an htmlTag option that
// looked like it handled this; it does the opposite -- it READS the attribute,
// and only when 'htmlTag' is in the detection order, which it never was.
// Read resolvedLanguage, never the language that was asked for: a browser
// reporting de-DE resolves to the English bundle, and stamping lang="de" on a
// page showing English copy is worse than leaving it alone.
const syncHtmlLang = () => {
    const shown = i18n.resolvedLanguage || i18n.language || 'en';
    document.documentElement.lang = shown.toLowerCase().split('-')[0];
};
syncHtmlLang();
i18n.on('languageChanged', syncHtmlLang);

export default i18n;
